import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { ConfirmationMessageType } from './confirmation-message-type.interface';

export class ConfirmationMessageTypeService {
   async getConfirmationMessageTypes(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<ConfirmationMessageType>>>(`/confirmation-message-types`, {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }

   async getConfirmationMessageType() {
      throw Error('Method not implemented');
   }

   async postConfirmationMessageType() {
      throw Error('Method not implemented');
   }

   async putConfirmationMessageType() {
      throw Error('Method not implemented');
   }

   async deleteConfirmationMessageType() {
      throw Error('Method not implemented');
   }
}
